var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"floating-message alert",class:_vm.messageClass},[(_vm.iconClass)?_c('i',{staticClass:"fa-lg m-r-20",class:_vm.iconClass}):_vm._e(),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }